var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	92769: () => (loadSingletonVersion("default", "react", true, [1,18,2,0], () => (() => (__webpack_require__(96540))))),
	59783: () => (loadSingletonVersion("default", "react-dom", true, [1,18,2,0], () => (() => (__webpack_require__(40961))))),
	54644: () => (loadSingletonVersion("default", "@tanstack/react-query", true, [1,5,100,1], () => (() => (__webpack_require__(85946))))),
	19873: () => (loadStrictVersion("default", "@cocounsel/basenji", false, [2,0,12,5], () => (__webpack_require__.e(7667).then(() => (() => (__webpack_require__(97667))))))),
	22831: () => (loadSingletonVersion("default", "@cocounsel/prometheus", false, [1,3,0,158], () => (Promise.all([__webpack_require__.e(7147), __webpack_require__.e(2190), __webpack_require__.e(4141), __webpack_require__.e(4341), __webpack_require__.e(9783), __webpack_require__.e(4499)]).then(() => (() => (__webpack_require__(34341))))))),
	53638: () => (loadSingletonVersion("default", "zustand", true, [1,4,5,2], () => (() => (__webpack_require__(34085))))),
	98732: () => (loadStrictVersion("default", "@cocounsel/harmonia", false, [1,1,2,1], () => (__webpack_require__.e(2025).then(() => (() => (__webpack_require__(32025))))))),
	54905: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,13,3], () => (__webpack_require__.e(2046).then(() => (() => (__webpack_require__(2046))))))),
	23100: () => (loadSingletonVersion("default", "@cocounsel/prometheus/material", false, [1,3,0,158], () => (Promise.all([__webpack_require__.e(4141), __webpack_require__.e(9783)]).then(() => (() => (__webpack_require__(14141))))))),
	93655: () => (loadStrictVersion("default", "@popperjs/core", false, [1,2,11,8], () => (__webpack_require__.e(1170).then(() => (() => (__webpack_require__(1170))))))),
	63588: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,73,1], () => (__webpack_require__.e(7286).then(() => (() => (__webpack_require__(97286))))))),
	48173: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(2485).then(() => (() => (__webpack_require__(32485))))))),
	55912: () => (loadStrictVersion("default", "unified", false, [1,11,0,5], () => (Promise.all([__webpack_require__.e(6945), __webpack_require__.e(6817)]).then(() => (() => (__webpack_require__(16817))))))),
	97507: () => (loadStrictVersion("default", "remark-parse", false, [1,11,0,0], () => (__webpack_require__.e(5415).then(() => (() => (__webpack_require__(75415))))))),
	58910: () => (loadStrictVersion("default", "remark-rehype", false, [1,11,1,2], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(2172)]).then(() => (() => (__webpack_require__(12172))))))),
	6105: () => (loadStrictVersion("default", "rehype-stringify", false, [1,10,0,1], () => (Promise.all([__webpack_require__.e(4871), __webpack_require__.e(1742)]).then(() => (() => (__webpack_require__(61742))))))),
	14067: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(4871), __webpack_require__.e(6945), __webpack_require__.e(1367)]).then(() => (() => (__webpack_require__(71367))))))),
	21084: () => (loadStrictVersion("default", "rehype-raw", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(4871), __webpack_require__.e(851)]).then(() => (() => (__webpack_require__(60851))))))),
	30919: () => (loadStrictVersion("default", "rehype-sanitize", false, [1,6,0,0], () => (__webpack_require__.e(9515).then(() => (() => (__webpack_require__(99515))))))),
	70811: () => (loadStrictVersion("default", "remark-gfm", false, [1,4,0,0], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(9419), __webpack_require__.e(143)]).then(() => (() => (__webpack_require__(20143))))))),
	95982: () => (loadStrictVersion("default", "immer", false, [1,10,1,1], () => (__webpack_require__.e(3575).then(() => (() => (__webpack_require__(73575))))))),
	97158: () => (loadSingletonVersion("default", "@mui/x-license", false, [4,8,29,2], () => (__webpack_require__.e(7097).then(() => (() => (__webpack_require__(29478))))))),
	46976: () => (loadStrictVersion("default", "react-virtuoso", false, [1,4,10,4], () => (__webpack_require__.e(5778).then(() => (() => (__webpack_require__(35778))))))),
	46071: () => (loadStrictVersion("default", "@platejs/markdown", false, [1,51,0,0], () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(9419), __webpack_require__.e(994), __webpack_require__.e(5762), __webpack_require__.e(8711)]).then(() => (() => (__webpack_require__(20994))))))),
	79166: () => (loadStrictVersion("default", "exceljs", false, [1,4,4,0], () => (__webpack_require__.e(4974).then(() => (() => (__webpack_require__(24974))))))),
	75331: () => (loadSingletonVersion("default", "@mui/x-data-grid-premium", false, [1,8,29,2], () => (Promise.all([__webpack_require__.e(7748), __webpack_require__.e(780), __webpack_require__.e(6970), __webpack_require__.e(5528), __webpack_require__.e(5590), __webpack_require__.e(8376), __webpack_require__.e(123), __webpack_require__.e(5923), __webpack_require__.e(9783), __webpack_require__.e(3655), __webpack_require__.e(2723), __webpack_require__.e(9143)]).then(() => (() => (__webpack_require__(25923))))))),
	28711: () => (loadStrictVersion("default", "platejs", false, [1,51,0,0], () => (Promise.all([__webpack_require__.e(8055), __webpack_require__.e(6134), __webpack_require__.e(7616), __webpack_require__.e(5504), __webpack_require__.e(5982)]).then(() => (() => (__webpack_require__(28775))))))),
	95621: () => (loadStrictVersion("default", "@tanstack/react-query-devtools", false, [1,5,100,1], () => (__webpack_require__.e(6695).then(() => (() => (__webpack_require__(56695))))))),
	12915: () => (loadStrictVersion("default", "franc", false, [1,6,2,0], () => (__webpack_require__.e(5551).then(() => (() => (__webpack_require__(55551))))))),
	23540: () => (loadStrictVersion("default", "@saffron/core-components", false, [1,3,11,1], () => (Promise.all([__webpack_require__.e(2190), __webpack_require__.e(9317), __webpack_require__.e(3166)]).then(() => (() => (__webpack_require__(53166))))))),
	23408: () => (loadStrictVersion("default", "react-use-measure", false, [1,2,1,7], () => (__webpack_require__.e(4688).then(() => (() => (__webpack_require__(34688))))))),
	93059: () => (loadStrictVersion("default", "@platejs/indent", false, [1,51,0,0], () => (__webpack_require__.e(7222).then(() => (() => (__webpack_require__(44841))))))),
	3239: () => (loadStrictVersion("default", "@platejs/list", false, [1,51,0,0], () => (__webpack_require__.e(1983).then(() => (() => (__webpack_require__(1983))))))),
	28099: () => (loadStrictVersion("default", "@platejs/floating", false, [1,51,0,0], () => (Promise.all([__webpack_require__.e(9317), __webpack_require__.e(57)]).then(() => (() => (__webpack_require__(60057))))))),
	45595: () => (loadStrictVersion("default", "@platejs/table", false, [1,51,0,0], () => (__webpack_require__.e(2173).then(() => (() => (__webpack_require__(2173))))))),
	54697: () => (loadStrictVersion("default", "uuid", false, [1,14,0,0], () => (__webpack_require__.e(4226).then(() => (() => (__webpack_require__(4226))))))),
	55195: () => (loadStrictVersion("default", "@platejs/layout", false, [1,51,0,0], () => (__webpack_require__.e(3878).then(() => (() => (__webpack_require__(21497))))))),
	59427: () => (loadStrictVersion("default", "@platejs/link", false, [1,51,0,0], () => (__webpack_require__.e(3216).then(() => (() => (__webpack_require__(20835))))))),
	94243: () => (loadStrictVersion("default", "@platejs/autoformat", false, [1,51,0,0], () => (__webpack_require__.e(727).then(() => (() => (__webpack_require__(50727))))))),
	94399: () => (loadStrictVersion("default", "@platejs/basic-styles", false, [1,51,0,0], () => (__webpack_require__.e(8903).then(() => (() => (__webpack_require__(11284))))))),
	1254: () => (loadSingletonVersion("default", "react-router", true, [1,7,18,2], () => (() => (__webpack_require__(95632))))),
	64677: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(7796).then(() => (() => (__webpack_require__(77796))))))),
	15634: () => (loadStrictVersion("default", "ky", false, [1,1,7,2], () => (__webpack_require__.e(6834).then(() => (() => (__webpack_require__(26834))))))),
	30180: () => (loadStrictVersion("default", "lexical", false, [2,0,38,2], () => (__webpack_require__.e(2859).then(() => (() => (__webpack_require__(62859))))))),
	91524: () => (loadStrictVersion("default", "@cocounsel/cocounsel-skill-mapping", false, [4,1,1,25], () => (__webpack_require__.e(2260).then(() => (() => (__webpack_require__(22260))))))),
	16191: () => (loadStrictVersion("default", "react-intersection-observer", false, [1,9,8,1], () => (__webpack_require__.e(471).then(() => (() => (__webpack_require__(80471))))))),
	24499: () => (loadStrictVersion("default", "@datadog/browser-rum", false, [1,6,22,0], () => (Promise.all([__webpack_require__.e(7936), __webpack_require__.e(8953)]).then(() => (() => (__webpack_require__(48953))))))),
	82723: () => (loadSingletonVersion("default", "@mui/x-data-grid", false, [1,8,29,2], () => (__webpack_require__.e(3396).then(() => (() => (__webpack_require__(63396))))))),
	89143: () => (loadSingletonVersion("default", "@mui/x-data-grid-pro", false, [1,8,29,2], () => (__webpack_require__.e(7818).then(() => (() => (__webpack_require__(7818))))))),
	14628: () => (loadStrictVersion("default", "react-window", false, [1,1,8,11], () => (__webpack_require__.e(88).then(() => (() => (__webpack_require__(60088))))))),
	94523: () => (loadSingletonVersion("default", "zone.js", false, [2,0,14,10], () => (__webpack_require__.e(8216).then(() => (() => (__webpack_require__(38216)))))))
};
var initialConsumes = [92769];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"2614": [
		75331
	],
	"2723": [
		82723
	],
	"2825": [
		12915,
		23540
	],
	"3059": [
		93059
	],
	"3100": [
		23100
	],
	"3408": [
		23408
	],
	"3588": [
		63588
	],
	"3610": [
		14628
	],
	"3655": [
		93655
	],
	"3990": [
		3239,
		28099,
		45595,
		54697,
		55195,
		59427,
		94243,
		94399
	],
	"4499": [
		24499
	],
	"4523": [
		94523
	],
	"4644": [
		54644
	],
	"4905": [
		54905
	],
	"5621": [
		95621
	],
	"5762": [
		55912,
		97507
	],
	"5982": [
		95982
	],
	"6046": [
		19873,
		22831,
		53638,
		98732
	],
	"6976": [
		46976
	],
	"7158": [
		97158
	],
	"7843": [
		1254,
		64677,
		15634,
		30180,
		91524,
		16191
	],
	"8173": [
		48173
	],
	"8701": [
		46071,
		79166
	],
	"8711": [
		28711
	],
	"8792": [
		92769
	],
	"8845": [
		6105,
		14067,
		21084,
		30919,
		70811
	],
	"8910": [
		58910
	],
	"9143": [
		89143
	],
	"9783": [
		59783
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}